import { useQuery } from "react-query";
import axios from 'axios';
import DataContext from 'UserRegistration/contexts/DataContext';
import {useContext, useRef, useEffect} from 'react';
import { NotFoundError } from "commons/errors/notFound";


export function useFetchPromoCode(promoCode) {
    const { registrationData, setRegistrationData } = useContext(DataContext);
    const registrationDataRef = useRef(registrationData);
    useEffect(() => {
        registrationDataRef.current = registrationData;
    });

    return useQuery(['useFetchPromoCode', promoCode], async () => {
        const config = {
            method: 'GET',
            url: '/public/user-registration/available-promo-code',
            params: {
                promoCode: promoCode
            },
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.request(config)
        let registrationDataCopy = Object.assign({}, registrationDataRef.current);

        if (response) {
            registrationDataCopy.registrationModel.subscription.promoCodeId = response.data.promoCodeId;

            // This data is used for display pourposes.
            registrationDataCopy.registrationModel.promotion.id = response.data.promoCodeId;
            registrationDataCopy.registrationModel.promotion.code = response.data.promoCode;
            registrationDataCopy.registrationModel.promotion.description = response.data.promoCodeDescription;
            registrationDataCopy.registrationModel.promotion.type = response.data.promoCodeType;
            registrationDataCopy.registrationModel.promotion.amount = response.data.promoCodeAmount;
            registrationDataCopy.registrationModel.promotion.supportedSubscriptionItems = response.data.supportedSubscriptionItems;
        }

        setRegistrationData(registrationDataCopy);

        if(response.status == 204) {
            throw new NotFoundError('Promo code not found', {code: 204})
        }
        return response.data
    }, {enabled: false, refetchOnWindowFocus: false, retry: false})
} 